export function removeSubstring(inputString) {
  return inputString !== undefined && inputString.replace("TEST", "");
}
